import React, { useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import taxiIcon from '../../assets/img/taxi-icon.png';
import wavIcon from '../../assets/img/wav-icon.png';
import blackIcon from '../../assets/img/black-icon.png';
import friendsIcon from '../../assets/img/friends-icon.png';
import meteredIcon from '../../assets/img/metered-icon.png';
import '../../assets/styles/ridetype-select.sass';

const RideTypeSelect = ({ fieldKey }) => {
  const key = fieldKey;
  const context = useContext(BookerContext);
  const {
    state: { serviceTypesAndAmounts, defaultServiceType } = {},
    updateDefaultServiceType,
    updateFare,
    updateIsMeteredFare,
  } = context;

  const selectRideType = (e, type) => {
    const selectedServiceType = serviceTypesAndAmounts[type];
    updateDefaultServiceType(type);
    updateFare(selectedServiceType);
    updateIsMeteredFare(selectedServiceType?.fare_type === 'meter');
  };

  const getImageUrl = type => {
    if (!type?.image_url) return type === 'limo' ? blackIcon : type === 'wav' ? wavIcon : taxiIcon;

    return type.image_url;
  };

  if (!(serviceTypesAndAmounts && defaultServiceType)) return <></>;

  return (
    <div className={`form-group form-group-${key}`}>
      {Object.keys(serviceTypesAndAmounts).map((type, i) => {
        const selectedType = serviceTypesAndAmounts[type];
        const totalAmount = selectedType?.total_amount;
        const amount = selectedType?.amount;
        const isMeteredRide = selectedType?.fare_type === 'meter';
        return (
          <div
            key={i}
            className={`form-group-rideType-content ${type}-ride-type ${
              defaultServiceType === type ? 'default-service-type-select' : ''
            }`}
            onClick={e => selectRideType(e, type)}
          >
            <div className="rideType-icon-container">
              <img src={getImageUrl(selectedType)} alt={`${type}`} className={`${type}-ride-type`} />
            </div>
            <div className={`rideType-text-content ${type}-ride-type`}>
              <div className="rideType-text">{selectedType.display_name}</div>
              <div className="rideType-passengersNumber">
                <img src={friendsIcon} alt="number of riders" className="number-of-riders" />
                {selectedType.capacity || 4}
              </div>
            </div>
            {isMeteredRide && (
              <div className={`rideType-price metered ${type}-ride-type`}>
                <div className="metered-title">Metered Est.</div>
                <div className="metered-price">
                  {/*<img src={meteredIcon} alt="metered ride" className="metered-icon" />*/}~ $
                  {amount ? (amount / 100).toFixed(2) : ''}
                </div>
                {/*<div className="metered-total-title">${totalAmount ? (totalAmount / 100).toFixed(2) : ''}</div>*/}
              </div>
            )}
            {!isMeteredRide && (
              <div className={`rideType-price ${type}-ride-type`}>${amount ? (amount / 100).toFixed(2) : ''}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RideTypeSelect;
